import React, { useState, useEffect } from 'react';
import './ProzessModal.css';

const ProzessModal = ({ prozess, onSave, onCancel }) => {
    const [activeTab, setActiveTab] = useState('basis');
    const [formData, setFormData] = useState({
        prozess_name: '',
        prozess_beschreibung: '',
        prozess_verantwortlicher: '',
        prozess_kategorie: '',
        // Compliance-Felder
        ist_kritisch: false,
        auslagerungsrelevant: false,
        verantwortlicher: '',
        notfallkonzept_vorhanden: false,
        it_strategie_vorhanden: false,
        risikoinventur_vorhanden: false,
        geschaeftsfortfuehrungsplan_vorhanden: false,
        incident_response_plan_vorhanden: false,
        informationssicherheitsleitlinie_vorhanden: false,
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (prozess) {
            setFormData({
                prozess_name: prozess.prozess_name || '',
                prozess_beschreibung: prozess.prozess_beschreibung || '',
                prozess_verantwortlicher: prozess.prozess_verantwortlicher || '',
                prozess_kategorie: prozess.prozess_kategorie || '',
                // Compliance-Felder
                ist_kritisch: prozess.ist_kritisch || false,
                auslagerungsrelevant: prozess.auslagerungsrelevant || false,
                verantwortlicher: prozess.verantwortlicher || '',
                notfallkonzept_vorhanden: prozess.notfallkonzept_vorhanden || false,
                it_strategie_vorhanden: prozess.it_strategie_vorhanden || false,
                risikoinventur_vorhanden: prozess.risikoinventur_vorhanden || false,
                geschaeftsfortfuehrungsplan_vorhanden: prozess.geschaeftsfortfuehrungsplan_vorhanden || false,
                incident_response_plan_vorhanden: prozess.incident_response_plan_vorhanden || false,
                informationssicherheitsleitlinie_vorhanden: prozess.informationssicherheitsleitlinie_vorhanden || false,
            });
        }
    }, [prozess]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error for this field
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: null
            }));
        }
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const validate = () => {
        const newErrors = {};

        if (!formData.prozess_name.trim()) {
            newErrors.prozess_name = 'Prozessname ist erforderlich';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validate()) {
            return;
        }

        onSave(formData);
    };

    return (
        <div className="modal-overlay" onClick={onCancel}>
            <div className="modal prozess-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>{prozess ? 'Prozess bearbeiten' : 'Neuer Prozess'}</h2>
                    <button className="modal-close" onClick={onCancel}>×</button>
                </div>

                {/* TAB NAVIGATION */}
                <div className="modal-tabs">
                    <button
                        type="button"
                        className={`tab-button ${activeTab === 'basis' ? 'active' : ''}`}
                        onClick={() => setActiveTab('basis')}
                    >
                        📋 Basisdaten
                    </button>
                    <button
                        type="button"
                        className={`tab-button ${activeTab === 'compliance' ? 'active' : ''}`}
                        onClick={() => setActiveTab('compliance')}
                    >
                        🔒 Compliance
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        {/* TAB: BASISDATEN */}
                        {activeTab === 'basis' && (
                            <div className="tab-content">
                                <div className="form-group">
                                    <label className="form-label">
                                        Prozessname <span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="prozess_name"
                                        className={`form-input ${errors.prozess_name ? 'error' : ''}`}
                                        value={formData.prozess_name}
                                        onChange={handleChange}
                                        placeholder="z.B. Kreditvergabe"
                                    />
                                    {errors.prozess_name && (
                                        <span className="error-message">{errors.prozess_name}</span>
                                    )}
                                </div>

                                <div className="form-group">
                                    <label className="form-label">Beschreibung</label>
                                    <textarea
                                        name="prozess_beschreibung"
                                        className="form-input form-textarea"
                                        value={formData.prozess_beschreibung}
                                        onChange={handleChange}
                                        placeholder="Kurze Beschreibung des Prozesses"
                                        rows={4}
                                    />
                                </div>

                                <div className="form-grid">
                                    <div className="form-group">
                                        <label className="form-label">Prozess-Verantwortlicher</label>
                                        <input
                                            type="text"
                                            name="prozess_verantwortlicher"
                                            className="form-input"
                                            value={formData.prozess_verantwortlicher}
                                            onChange={handleChange}
                                            placeholder="z.B. Max Mustermann"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label className="form-label">Kategorie</label>
                                        <select
                                            name="prozess_kategorie"
                                            className="form-select"
                                            value={formData.prozess_kategorie}
                                            onChange={handleChange}
                                        >
                                            <option value="">-- Bitte wählen --</option>
                                            <option value="Kernprozess">Kernprozess</option>
                                            <option value="Unterstützungsprozess">Unterstützungsprozess</option>
                                            <option value="Managementprozess">Managementprozess</option>
                                            <option value="IT-Prozess">IT-Prozess</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* TAB: COMPLIANCE */}
                        {activeTab === 'compliance' && (
                            <div className="tab-content">
                                <div className="compliance-section">
                                    <h3 className="section-title">⚠️ Kritikalität & Auslagerung</h3>
                                    <div className="checkbox-grid">
                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="ist_kritisch"
                                                checked={formData.ist_kritisch}
                                                onChange={handleCheckboxChange}
                                            />
                                            <span className="checkbox-text">
                                                Kritischer Prozess
                                                <small>Hohe Bedeutung für Geschäftsbetrieb</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="auslagerungsrelevant"
                                                checked={formData.auslagerungsrelevant}
                                                onChange={handleCheckboxChange}
                                            />
                                            <span className="checkbox-text">
                                                Auslagerungsrelevant
                                                <small>Prozess wird ausgelagert (BaFin MaRisk AT 9)</small>
                                            </span>
                                        </label>
                                    </div>
                                    <br/>
                                    <div className="form-group">
                                        <label className="form-label">Compliance-Verantwortlicher</label>
                                        <input
                                            type="text"
                                            name="verantwortlicher"
                                            className="form-input"
                                            value={formData.verantwortlicher}
                                            onChange={handleChange}
                                            placeholder="Name des Compliance-Verantwortlichen"
                                        />
                                        <small className="help-text">
                                            Verantwortliche Person für die Einhaltung regulatorischer Anforderungen
                                        </small>
                                    </div>
                                </div>

                                <div className="compliance-section">
                                    <h3 className="section-title">📋 Notfall- & Geschäftsfortführung</h3>
                                    <div className="checkbox-grid">
                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="notfallkonzept_vorhanden"
                                                checked={formData.notfallkonzept_vorhanden}
                                                onChange={handleCheckboxChange}
                                            />
                                            <span className="checkbox-text">
                                                Notfallkonzept vorhanden
                                                <small>BSI Standard 100-4, DORA Art. 11</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="geschaeftsfortfuehrungsplan_vorhanden"
                                                checked={formData.geschaeftsfortfuehrungsplan_vorhanden}
                                                onChange={handleCheckboxChange}
                                            />
                                            <span className="checkbox-text">
                                                Geschäftsfortführungsplan vorhanden
                                                <small>MaRisk AT 7.3, DORA Art. 11</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="incident_response_plan_vorhanden"
                                                checked={formData.incident_response_plan_vorhanden}
                                                onChange={handleCheckboxChange}
                                            />
                                            <span className="checkbox-text">
                                                Incident Response Plan vorhanden
                                                <small>DORA Art. 17-20</small>
                                            </span>
                                        </label>
                                    </div>
                                </div>

                                <div className="compliance-section">
                                    <h3 className="section-title">🔐 Governance & Strategie</h3>
                                    <div className="checkbox-grid">
                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="it_strategie_vorhanden"
                                                checked={formData.it_strategie_vorhanden}
                                                onChange={handleCheckboxChange}
                                            />
                                            <span className="checkbox-text">
                                                IT-Strategie vorhanden
                                                <small>BAIT 1.1, MaRisk AT 7.1</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="risikoinventur_vorhanden"
                                                checked={formData.risikoinventur_vorhanden}
                                                onChange={handleCheckboxChange}
                                            />
                                            <span className="checkbox-text">
                                                Risikoinventur vorhanden
                                                <small>MaRisk AT 2.2</small>
                                            </span>
                                        </label>

                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="informationssicherheitsleitlinie_vorhanden"
                                                checked={formData.informationssicherheitsleitlinie_vorhanden}
                                                onChange={handleCheckboxChange}
                                            />
                                            <span className="checkbox-text">
                                                Informationssicherheitsleitlinie vorhanden
                                                <small>BSI IT-Grundschutz ISMS.1</small>
                                            </span>
                                        </label>
                                    </div>
                                </div>

                                <div className="info-box">
                                    <strong>ℹ️ Hinweis:</strong> Diese Felder werden für die automatische GAP-Analyse verwendet.
                                    Fehlende Maßnahmen bei kritischen Prozessen führen automatisch zur Erstellung von Compliance-GAPs.
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="modal-actions">
                        <button type="button" onClick={onCancel} className="btn-secondary btn-medium">
                            Abbrechen
                        </button>
                        <button type="submit" className="btn-primary btn-medium">
                            {prozess ? 'Speichern' : 'Erstellen'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ProzessModal;